/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import type { Unsubscribe } from '@amazon/vinyl-util'
import { noop } from '@amazon/vinyl-util'

/**
 * Lazy — the server-sync drags gql + user-context helpers; load it off
 * the boot path so the feature tree-shakes when unused. The returned
 * disposer races the load: if the app reloads before the module
 * resolves, dispose unsubscribes the (by then installed) sign-in
 * listener via the captured cell.
 */
export function installExplicitLanguageFilterSyncLazy(): Unsubscribe {
    let syncDispose: (() => void) | null = null
    let disposed = false
    import('@/explicitLanguageFilter/explicitLanguageFilterSync')
        .then((m) => {
            if (disposed) return
            syncDispose = m.installExplicitLanguageFilterSync()
        })
        .catch(noop)
    return () => {
        disposed = true
        syncDispose?.()
    }
}
